import { API_BASE_URL } from '../constant/constant';

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || errorData.message || 'API request failed');
  }
  return response.json();
};

// API Key Management
export const createApiKey = async (keyData, token) => {
  const response = await fetch(`${API_BASE_URL}/developer/api-keys`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(keyData),
  });

  return handleResponse(response);
};

export const getApiKeys = async (token) => {
  const response = await fetch(`${API_BASE_URL}/developer/api-keys`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const revokeApiKey = async (keyId, token) => {
  const response = await fetch(`${API_BASE_URL}/developer/api-keys/${keyId}/revoke`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const deleteApiKey = async (keyId, token) => {
  const response = await fetch(`${API_BASE_URL}/developer/api-keys/${keyId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

// Analytics
export const getUsageAnalytics = async (periodOrToken, maybeToken) => {
  let token = maybeToken;
  let period = periodOrToken;

  if (!maybeToken) {
    token = periodOrToken;
    period = null;
  }

  const url = period
    ? `${API_BASE_URL}/developer/analytics/usage?period=${encodeURIComponent(period)}`
    : `${API_BASE_URL}/developer/analytics/usage`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

// Logs
export const getApiLogs = async (paramsOrToken = {}, maybeToken) => {
  let token = maybeToken;
  let params = paramsOrToken;

  if (typeof paramsOrToken === 'string') {
    token = paramsOrToken;
    params = {};
  }

  const queryParams = new URLSearchParams(params);
  const url = queryParams.toString()
    ? `${API_BASE_URL}/developer/logs?${queryParams}`
    : `${API_BASE_URL}/developer/logs`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};

export const getLogDetails = async (logId, token) => {
  const response = await fetch(`${API_BASE_URL}/developer/logs/${logId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  return handleResponse(response);
};
